export default __webpack_public_path__ + "static/media/p79.f55bc125.jpg";